import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateLastName from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError, fetchRealtimeValidations } from '../../data/actions';

/**
 * LastName field wrapper. It accepts following handlers
 * - handleChange for setting value change and
 * - handleErrorChange for setting error
 *
 * It is responsible for
 * - Performing last name field validations
 * - Clearing error on focus
 * - Setting value on change
 */
const LastNameField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const {
    handleErrorChange,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateLastName(value, formatMessage);
    if (fieldError) {
      handleErrorChange('last_name', fieldError);
    } else if (!validationApiRateLimited) {
      dispatch(fetchRealtimeValidations({ last_name: value }));
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('last_name', '');
    dispatch(clearRegistrationBackendError('last_name'));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

LastNameField.defaultProps = {
  errorMessage: '',
};

LastNameField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default LastNameField;
